import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=cec1dce6&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=cec1dce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec1dce6",
  null
  
)

export default component.exports